import { render } from "./PerTrend.vue?vue&type=template&id=5d17e7b3&scoped=true"
import script from "./PerTrend.vue?vue&type=script&lang=js"
export * from "./PerTrend.vue?vue&type=script&lang=js"

import "./PerTrend.vue?vue&type=style&index=0&id=5d17e7b3&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d17e7b3"]])

export default __exports__